// Tax Flow — shared formatting helpers (Enterprise Integration Pass, Phase 2).
// Pure, side-effect-free formatters. Single source of truth so date/money
// rendering stays consistent across every module. No business logic here.

const _date = (d) => (d ? new Date(d) : null);

// Short date, e.g. "Jun 28, 2026"
export const fmtDate = (d) => {
  const dt = _date(d);
  return dt ? dt.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) : "—";
};

// Compact date, e.g. "Jun 28"
export const fmtDateShort = (d) => {
  const dt = _date(d);
  return dt ? dt.toLocaleDateString(undefined, { month: "short", day: "numeric" }) : "—";
};

// Date + time, e.g. "Jun 28, 2026, 3:04 PM"
export const fmtDateTime = (d) => {
  const dt = _date(d);
  return dt ? dt.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }) : "—";
};

// Money with currency code, e.g. "USD 1,200" (no decimals by default)
export const fmtMoney = (v, currency = "USD", { decimals = 0 } = {}) =>
  `${currency} ${Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: decimals, minimumFractionDigits: decimals })}`;

// Money with $ symbol, e.g. "$1,200"
export const fmtUSD = (v, { decimals = 0 } = {}) =>
  `$${Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: decimals, minimumFractionDigits: decimals })}`;
